/**
 * assets/senze-forms-app-style-hack.js
 * 2026-07-22
 *
 * ⚠️ 这是一段"非官方"的补丁脚本，往 Shopify Forms App 的 Shadow DOM 内部强行塞样式，
 * 不是这个 App 官方支持的做法。原理：Shadow DOM 是 "open" 模式，虽然普通 <link>/<style>
 * 样式表进不去，但可以用 JS 拿到 shadowRoot 引用、往里面插一个 <style> 标签。
 *
 * 风险，之前已经跟 Zeke 说明并确认过：
 * - App 内部用的是自动生成的哈希 class 名（比如 _teaserContainer_trejf_5），
 *   App 只要更新版本，这些 class 名很可能会变，届时这段脚本会"安静地失效"
 *   （不报错，就是效果没了），需要重新打开浏览器审查工具确认新的 class/属性名，
 *   再回来改这个文件。
 * - 优先用 [data-testid="form-teaser"] 这个属性选择器，而不是哈希 class，
 *   因为 data-testid 这类属性通常是开发者特意留着给测试用的，
 *   相对哈希 class 更不容易随便改动，但也不保证一定不变。
 *
 * 效果：默认 50% 透明度，鼠标移上去恢复完全不透明；页面加载后每 3 秒跳动一次，
 * 跳 5 次后停止，不会一直循环打扰访客（跟之前咱们自己那个悬浮组件的设计一致）。
 */
(function () {
  var STYLE_ID = 'senze-forms-app-style-hack';
  var TRIGGER_SELECTOR = '[data-testid="form-teaser"]';
  var MAX_BOUNCES = 5;
  var BOUNCE_INTERVAL_MS = 3000;
  var BOUNCE_DURATION_MS = 800;

  function injectStyleIntoShadowRoot(shadowRoot) {
    if (shadowRoot.getElementById(STYLE_ID)) return; // 已经插过了，不重复插
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      TRIGGER_SELECTOR + ' {' +
      '  opacity: 0.5;' +
      '  transition: opacity 0.25s ease, transform 0.25s cubic-bezier(0.25, 0.8, 0.25, 1);' +
      '}' +
      TRIGGER_SELECTOR + ':hover,' +
      TRIGGER_SELECTOR + ':focus-within {' +
      '  opacity: 1;' +
      '}' +
      '@keyframes senze-forms-bounce {' +
      '  0%, 100% { transform: translateY(0); }' +
      '  30% { transform: translateY(-14px); }' +
      '  50% { transform: translateY(0); }' +
      '  65% { transform: translateY(-6px); }' +
      '  80% { transform: translateY(0); }' +
      '}' +
      TRIGGER_SELECTOR + '.senze-forms-bouncing {' +
      '  opacity: 1;' +
      '  animation: senze-forms-bounce ' + (BOUNCE_DURATION_MS / 1000) + 's ease;' +
      '}';
    shadowRoot.appendChild(style);
  }

  function startBounceLoop(shadowRoot) {
    var count = 0;
    var timer = setInterval(function () {
      if (count >= MAX_BOUNCES) {
        clearInterval(timer);
        return;
      }
      var trigger = shadowRoot.querySelector(TRIGGER_SELECTOR);
      if (trigger) {
        trigger.classList.add('senze-forms-bouncing');
        setTimeout(function () {
          trigger.classList.remove('senze-forms-bouncing');
        }, BOUNCE_DURATION_MS);
      }
      count++;
    }, BOUNCE_INTERVAL_MS);
  }

  function trySetup() {
    var host = document.querySelector('shopify-forms-embed');
    if (!host || !host.shadowRoot) return false;
    var trigger = host.shadowRoot.querySelector(TRIGGER_SELECTOR);
    if (!trigger) return false;
    injectStyleIntoShadowRoot(host.shadowRoot);
    startBounceLoop(host.shadowRoot);
    return true;
  }

  // App 是异步渲染 Shadow DOM 内容的，页面刚加载时可能还没渲染出来，
  // 所以不是加载完立刻找，是每隔一小段时间试一次，找到就停，
  // 试了 20 秒还没找到就放弃（避免一直空转）。
  var attempts = 0;
  var poll = setInterval(function () {
    attempts++;
    if (trySetup() || attempts > 40) {
      clearInterval(poll);
    }
  }, 500);
})();